import { Link } from "@tanstack/react-router";
import { openCookiePreferences } from "@/lib/cookie-consent";
import { InstallAppButton } from "@/components/InstallAppButton";



export function LegalFooter({
  variant = "dark",
}: {
  variant?: "dark" | "light";
}) {
  const base =
    variant === "dark"
      ? "border-border text-muted-foreground/70 hover:text-accent"
      : "border-foreground/10 text-foreground/50 hover:text-foreground";
  const link =
    variant === "dark"
      ? "text-muted-foreground hover:text-accent"
      : "text-foreground/60 hover:text-foreground";

  return (
    <footer
      className={`border-t ${base.split(" ")[0]} px-8 py-10 lg:px-16`}
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-6 md:flex-row md:items-start md:justify-between">
        <div className={`text-xs ${variant === "dark" ? "text-muted-foreground/70" : "text-foreground/50"} max-w-md`}>
          <p>The Hospitality Reserve</p>
          <p className="mt-2 leading-relaxed">
            The Hospitality Reserve is a neutral technology platform. We are not an
            employer, employment business, or employment agency. Bartenders
            are self-employed independent contractors and contract directly
            with venues.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 text-[11px] tracking-wide-luxury">
          <Link to="/legal/terms" className={link}>
            Terms
          </Link>
          <Link to="/legal/privacy" className={link}>
            Privacy
          </Link>
          <Link to="/legal/cookies" className={link}>
            Cookies
          </Link>
          <Link to="/legal/acceptable-use" className={link}>
            Acceptable Use
          </Link>
          <Link to="/legal/contractor-agreement" className={link}>
            Contractor Agreement
          </Link>
          <Link to="/legal/modern-slavery" className={link}>
            Modern Slavery
          </Link>
          <button
            type="button"
            onClick={openCookiePreferences}
            className={`${link} cursor-pointer bg-transparent p-0`}
          >
            Manage cookies
          </button>
          <Link to="/install" className={link}>
            Install app
          </Link>
        </nav>
      </div>
      <div className="mx-auto mt-6 flex max-w-6xl justify-start md:hidden">
        <InstallAppButton label="Add to Home Screen" />
      </div>
    </footer>
  );
}
